import { Discipline } from '../models/filter/discipline/Discipline';
import { IDisciplinesRepository } from '../interfaces/presenters.interfaces';
import { disciplinesAll } from '@studyportals/static-domain-data/disciplines/disciplines';
import { subdisciplinesAll } from '@studyportals/static-domain-data/disciplines/subdisciplines';
import { disciplineGetVirtualPath } from '@studyportals/static-domain-data/disciplines/discipline-get-virtual-path';
import { disciplineGetSynonym } from '@studyportals/static-domain-data/disciplines/discipline-get-synonym';
import { ISubDiscipline } from '@studyportals/static-domain-data/disciplines/i-sub-discipline';
import { IDiscipline } from '@studyportals/static-domain-data/disciplines/i-discipline';

class DisciplinesRepository implements IDisciplinesRepository {
	public getDisciplines(): Discipline[] {
		return this.reconstituteDisciplines();
	}

	public hasDisciplineId(discipline: IDiscipline | ISubDiscipline): discipline is ISubDiscipline {
		return 'disciplineId' in discipline;
	}

	private reconstituteDisciplines(): Discipline[] {
		const disciplines: Discipline[] = [];
		const allDisciplines = [...disciplinesAll, ...subdisciplinesAll];

		allDisciplines.forEach((discipline: IDiscipline | ISubDiscipline) => {
			const virtualPath = disciplineGetVirtualPath(discipline.id.toString());
			const synonym = disciplineGetSynonym(discipline.id.toString());
			const disciplineId = this.hasDisciplineId(discipline) ? discipline.disciplineId : undefined;

			disciplines.push(
				new Discipline(
					discipline.id.toString(),
					discipline.name,
					virtualPath ?? '',
					synonym ?? undefined,
					disciplineId?.toString() ?? undefined,
					discipline.icon
				)
			);
		});
		return disciplines;
	}
}

export default new DisciplinesRepository();
